




















































import { Component, Prop, Vue } from "vue-property-decorator";
import ChevronRightSolid from "~/components/icons/ChevronRightSolid.vue";
import ChevronTopSolid from "~/components/icons/ChevronTopSolid.vue";

@Component({
  components: { ChevronTopSolid, ChevronRightSolid },
})
export default class SportsPicker extends Vue {
  @Prop(Object) sport: Types.SportItem;
  @Prop({ type: Array, default: () => [] }) value : Array<number | string>;
  @Prop(Array) availableSports: [{title : string, sports : [] }];
  display: boolean = this.shouldBeDisplayed;
  selected: boolean = false;

  get shouldBeDisplayed () {
    return !!this.sport.children?.some(child => this.isSelected(child.id));
  }

  get displayChevron () {
    const childSelected = this.sport.children?.every(child => this.isSelected(child.id));
    const childUnselected = this.sport.children?.every(child => !this.isSelected(child.id));
    return !!(childSelected || childUnselected);
  }

  isSelected (sportId : number | string) {
    this.value.forEach((s, index) => {
      if (typeof s === "string") this.value[index] = parseInt(s, 10);
    });
    return this.value.includes(sportId);
  }

  displayNextDiv () {
    this.display = !this.display;
  }

  sendSportToParent (element: any) {
    element.id.toString();
    let newValue = [...this.value];
    // if element is not already selected push-it
    if (!this.isSelected(element.id)) {
      newValue.push(element.id);
      // if element has a parent find-it an if all these children are selected, push-it
      if (element.parent_id) {
        const universeIndex = this.availableSports.findIndex((obj: { title: string; }) => obj.title === element.universe);
        const sportsOfTheUniverse: Array<{ id: string; children: [] }> = this.availableSports[universeIndex].sports;
        const parentIndex = sportsOfTheUniverse.findIndex((obj: { id: string; }) => obj.id === element.parent_id);
        const isAllChildrenSelected = sportsOfTheUniverse[parentIndex].children.every((child: { id: number|string; }) => newValue.includes(child.id));
        const manyChildren = sportsOfTheUniverse[parentIndex].children.length > 1;
        // if the parent has more than one children and all this children are selected
        if (isAllChildrenSelected && manyChildren) {
          newValue.push(sportsOfTheUniverse[parentIndex].id);
        }
        // if element has children we add them
      } else if (element.children) {
        element.children.forEach((child: {id: string, title: string, parent_id: string }) => {
          newValue.push(child.id);
        });
      }
    } else {
      /* eslint array-callback-return: 0 */
      if (element.children) {
        /* if element has children, then each child will be untoggle too /
        filter newValue for remove the child from this array */
        element.children.forEach((child: { id: any }) => {
          newValue = newValue.filter(sportId => sportId !== child.id);
        });
        // if element has a parent we remove them too
      } else if (element.parent_id) {
        newValue = newValue.filter(sportId => sportId !== element.parent_id);
      }
      newValue = newValue.filter(sportId => sportId !== element.id);
    }
    this.$emit('input', Array.from(new Set(newValue)));
  }
}
